import { siteConfig } from "@latam-energy/content";

export interface EmailPayload {
  name: string;
  email: string;
  company: string;
  phone: string;
  position?: string;
  country: string;
  city: string;
  interest: string;
  quantity?: string;
  message: string;
  projectDescription?: string;
  preferredContact: "email" | "telefono" | "whatsapp";
  formType: "contacto" | "cotizacion";
}

export async function sendFormEmail(payload: EmailPayload): Promise<{ success: boolean; message: string }> {
  try {
    // Call AWS Lambda endpoint
    const lambdaUrl = import.meta.env.VITE_LAMBDA_EMAIL_ENDPOINT;
    
    if (!lambdaUrl) {
      console.warn("VITE_LAMBDA_EMAIL_ENDPOINT not configured. Email not sent.");
      return { success: false, message: "Email service not configured yet." };
    }

    const response = await fetch(lambdaUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...payload,
        recipientEmail: siteConfig.email,
        siteUrl: typeof window !== "undefined" ? window.location.origin : "",
      }),
    });

    if (!response.ok) {
      throw new Error(`Lambda returned ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      message: "Solicitud enviada correctamente. Te contactaremos pronto.",
    };
  } catch (error) {
    console.error("Error sending email:", error);
    return {
      success: false,
      message: "Error al enviar la solicitud. Por favor intenta de nuevo.",
    };
  }
}

/**
 * Generates a formatted email body for the admin notification
 */
export function formatEmailBody(payload: EmailPayload): string {
  const formType = payload.formType === "cotizacion" ? "Solicitud de Cotización" : "Contacto";
  
  const details = [
    `TIPO: ${formType}`,
    `\nDATA DEL SOLICITANTE:`,
    `- Nombre: ${payload.name}`,
    `- Email: ${payload.email}`,
    `- Empresa: ${payload.company}`,
    `- Cargo: ${payload.position || "No especificado"}`,
    `- Teléfono: ${payload.phone}`,
    `- País: ${payload.country}`,
    `- Ciudad: ${payload.city}`,
    `\nDETALLES DE LA SOLICITUD:`,
    `- Servicio/Producto de Interés: ${payload.interest}`,
    payload.quantity ? `- Cantidad Estimada: ${payload.quantity}` : "",
    `- Método de Contacto Preferido: ${payload.preferredContact}`,
    `\nMENSAJE:`,
    payload.message,
    payload.projectDescription ? `\nDESCRIPCIÓN DEL PROYECTO:\n${payload.projectDescription}` : "",
  ]
    .filter(Boolean)
    .join("\n");

  return details;
}
